import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=51c0a900&scoped=true&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=51c0a900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0a900",
  null
  
)

export default component.exports